export default __webpack_public_path__ + "static/media/grade-st-500.d6a6364a.png";